import {
  Component,
  effect,
  ElementRef,
  EventEmitter,
  input,
  Output,
  output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModuleLib } from '../../../shared.module';
import { isMobileScreen } from '@core/utils';

@Component({
  selector: 'agenda-customer-ui-selectable-option',
  standalone: true,
  imports: [CommonModule, SharedModuleLib],
  templateUrl: './selectableOption.component.html',
  styleUrls: ['./selectableOption.component.scss'],
})
export class SelectableOptionComponent {
  // Visual fields
  title = input();
  price = input();
  subtitleColor = input<string>('medium-blue');
  description = input<string>('');
  costless = input<boolean>();

  // Logic behind each option
  optionId = input<number>();
  // Logic related to checking/unchecking the boxes
  @ViewChild('checkboxElement') checkboxElement!: ElementRef<HTMLInputElement>;
  isChecked = input<boolean>(false);
  isCheckedState = false;
  isCheckedOnStateChange = output<boolean>();
  isMobileScreen = isMobileScreen();
  openTooltip = false;

  buttonPosition = 0;

  @Output() showTooltip = new EventEmitter<boolean>();
  @Output() optionSelected = new EventEmitter<{
    title: string;
    price: string;
    subtitleColor: string;
    description: string;
    costless: boolean;
    buttonPosition: number
  }>();

  // TODO: Encontrar uma alternativa ao target e ElementRef. Atualmente
  // parece ser uma limitação do conteúdo projetado no modal do FDS, que faz
  // com que cliques nos inputs dentro do modal não sejam registrados. Como
  // forma de resolver o problema, estou lidando com os cliques no desktop
  // de forma diferente com que lido com os cliques no mobile.

  constructor() {
    effect(() => {
      this.isCheckedState = this.isChecked();
    });
  }

  toggleChecked() {
    if (this.isMobileScreen) {
      this.isCheckedState = !this.isCheckedState;
      this.isCheckedOnStateChange.emit(this.isCheckedState);
    }
  }

  handleTooltipClose(): void {
    this.showTooltip.emit(false);
  }

  dialogOpen(event: Event) {
    const element = event.currentTarget as HTMLElement;
    const rect = element.getBoundingClientRect();

    const marginTop = 37;

    if(this.description()?.length > 0 && rect.top >= 300){
      this.buttonPosition = 250
    }else{
      this.buttonPosition = rect.top - marginTop;
    }

    this.emitOptionData();
    this.showTooltip.emit(true);
  }

  emitOptionData() {
    this.optionSelected.emit({
      title: this.title() as string,
      price: this.price() as string,
      subtitleColor: this.subtitleColor(),
      description: this.description(),
      costless: this.costless() as boolean,
      buttonPosition: this.buttonPosition as number,
    });
  }

  onContainerClick(event: MouseEvent) {
    if (!this.isMobileScreen) {
      event.stopPropagation();
      const target = event.target as HTMLElement;
      if (!target.closest('.option__info')) {
        this.isCheckedState = !this.isCheckedState;
        this.isCheckedOnStateChange.emit(this.isCheckedState);

        if (this.checkboxElement && this.isCheckedState) {
          this.checkboxElement.nativeElement.checked = this.isCheckedState;
        }
      }
    }
  }
}
